import { combineDucks } from "lib/utils/duck";

import CustomersListView from "./CustomersListView/index";
import EditCustomerModal from "./EditCustomerModal/index";
import ShowCustomerView from "./ShowCustomerView/index";

export default combineDucks({
  CustomersListView,
  EditCustomerModal,
  ShowCustomerView,
});



// WEBPACK FOOTER //
// ./src/modules/customers/index.js